import { useState } from "react";

const items = [
  "React",
  "FastAPI",
  "MongoDB",
  "TailwindCSS",
  "Framer Motion",
  "Booking Systems",
  "Admin Dashboards",
  "E-commerce",
  "AI Integrations",
  "SEO & Speed",
  "Design Systems",
  "Landing Pages",
];

export default function Marquee() {
  const [paused, setPaused] = useState(false);
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee-strip"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onTouchStart={() => setPaused(true)}
      onTouchEnd={() => setPaused(false)}
      className="relative border-y border-white/10 bg-black/40 overflow-hidden py-6 group"
    >
      <div
        className="marquee-track flex gap-12 whitespace-nowrap w-max marquee-responsive"
        style={{ animationPlayState: paused ? "paused" : "running" }}
      >
        {row.map((it, i) => (
          <div
            key={i}
            className="flex items-center gap-4 font-display text-2xl md:text-3xl font-medium text-white/70"
          >
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#E2FF31]" />
            {it}
          </div>
        ))}
      </div>
    </div>
  );
}
